








import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import WebSocketProvider from '@/websocket'
import { WebSocketClientInterface } from '@/websocket/types'
import { WebSocketEventTypes } from '@/websocket/constants'
import { Patient, Worker, Relative } from '@/types/user'

@Component
export default class VideoCallDispatch extends Vue {
  @Prop() toUsers!: { id: number; isPatient: boolean; isRelative: boolean }[]

  $store!: ExStore
  webSocket!: WebSocketClientInterface

  get callPartners() {
    return this.$store.getters['call/callPartners']
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get isRelative() {
    return this.user.isPatientRelative
  }

  get relativeInfo() {
    return this.$store.getters['user/relativeInfo']
  }

  get relativePatient() {
    return this.relativeInfo ? this.relativeInfo.patient : null
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  get relatives() {
    if (this.user.isPatientRelative) return []
    return this.$store.getters['relative/activeRelativeList']
  }

  get isCalling() {
    return this.$store.getters['videoCallRoom/isCalling']
  }

  get patientId(): number | null | undefined {
    return this.isRelative ? this.relativeInfo?.patient.id : this.user.id
  }
  //＝＝＝＝＝＝＝＝ ここから変更 F.Shiro 2025.0618
  async mounted() {
    await this.checkIsValidLogin()
    if (this.user.isPatient) {
      await this.$store.dispatch('relative/updateList')
    }

    this.$store.dispatch('videoCallRoom/setInCallWebView')

    this.webSocket = WebSocketProvider.createConnection()

    this.webSocket.addListener(WebSocketEventTypes.OPEN, () => {
      this.waitingVideoRoomReady()
    })

    // 接続がすでに開かれていた場合のフォールバック
    if (this.webSocket.readyState === WebSocket.OPEN) {
      this.waitingVideoRoomReady()
    }
  }
  //=========== ここまで
  /*
    async created() {
      await this.checkIsValidLogin()
      if (this.user.isPatient) await this.$store.dispatch('relative/updateList')
  
      this.$store.dispatch('videoCallRoom/setInCallWebView')
  
      this.webSocket = WebSocketProvider.createConnection()
      if (this.webSocket.readyState === WebSocket.OPEN) {
        this.waitingVideoRoomReady()
      } else {
        this.webSocket.addListener(WebSocketEventTypes.OPEN, (event: Event) => {
          this.waitingVideoRoomReady()
        })
      }
    }
  */

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      const name = this.user.isPatient ? 'PatientLogin' : 'Login'
      this.$router.replace({ name })
    }
  }

  async waitingVideoRoomReady() {
    if (this.user.isPatient || this.user.isPatientRelative) {
      this.$router.push({
        name: `${this.routePrefix}Call`
      })
    }
    const unsubscribe = this.$store.subscribe(({ type, payload }) => {
      //alert('waitingVideoRoomReady type=' + type)
      if (type === 'videoCallRoom/setVideoRoomReady' && payload) {
        this.call()
        unsubscribe()
      }
    })
  }

  async call() {
    const patientId = this.patientId
    if (!patientId) return

    const users = await this.getPartners()

    this.$store.dispatch('call/updateCallPartners', users)
    this.$store.dispatch('videoCallRoom/call', {
      users
    })
  }

  async getPartners() {
    const patientId = this.patientId
    if (!patientId) return []
    if (this.isRelative && this.relativePatient) {
      return [this.relativePatient as Patient]
    }
    const users = (
      await Promise.all(
        this.toUsers.map(async user => {
          try {
            if (user.isRelative) {
              return this.relatives.find(r => r.id === user.id)
            } else if (user.isPatient) {
              return await this.$api.user.patient({
                patientId: user.id
              })
            } else {
              return await this.$api.user.worker({ workerId: user.id })
            }
          } catch (e) {
            console.error(e)
          }
        })
      )
    ).filter(user => user !== undefined) as (Worker | Patient | Relative)[]
    return users
  }
}
